import {Component, Input} from '@angular/core';
import {DisplayMode, MarketingDetailCategoryInterface} from '../../../models/marketing-detail.model';

@Component({
  selector: 'app-plan-benefits',
  templateUrl: './plan-benefits.component.html',
  styleUrls: ['./plan-benefits.component.scss'],
  standalone: false
})

export class PlanBenefitsComponent {
  @Input() public planBenefits: MarketingDetailCategoryInterface | null = null;
  @Input() public ancillaryCodes: string = '';

  public getShowQuantity(): boolean {
    if (!this.planBenefits) return false;
    return this.planBenefits.displayMode === DisplayMode.FULL
      || this.planBenefits.displayMode === DisplayMode.SAVINGS_ONLY
      || this.planBenefits.displayMode === DisplayMode.QUANTITY_PAY
      || this.planBenefits.displayMode === DisplayMode.QUANTITY;
  }

  public getShowYouPay(): boolean {
    if (!this.planBenefits) return false;
    return this.planBenefits.displayMode === DisplayMode.FULL
      || this.planBenefits.displayMode === DisplayMode.PRICING_ONLY
      || this.planBenefits.displayMode === DisplayMode.QUANTITY_PAY;
  }

  public getShowYouSave(): boolean {
    if (!this.planBenefits) return false;
    return this.planBenefits.displayMode === DisplayMode.FULL || this.planBenefits.displayMode === DisplayMode.SAVINGS_ONLY;
  }

  public formatCurrency(value: number | string | null): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'number') return '$' + Math.round(value);
    if (typeof value === 'string') return value.replace(/\.00$/, '');
    return value;
  }

  public formatCurrencyNumber(value: number | string | null): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'number') return '' + Math.round(value);
    if (typeof value === 'string') return value.replace(/^\$/, '').replace(/\.00$/, '');
    return value;
  }

  public getYouSaveLabel(): string {
    return this.getShowYouPay() ? 'You Save' : 'Value';
  }

  public getDescriptionColumnClass(): string {
    const visibleColumns: number = [this.getShowQuantity(), this.getShowYouPay(), this.getShowYouSave()].filter(Boolean).length;
    return `col-${12 - visibleColumns * 2}`;
  }
}
